import { SupportedIntegrationsWithBrands, SupportedBrands } from '@sdk/integrations/types';

export const shift4integrations = [
  SupportedBrands.harbortouch,
  SupportedBrands.positouch,
  SupportedBrands.restaurantManager,
];

export const isShift4Integration = (integrationType: SupportedIntegrationsWithBrands): boolean => {
  return shift4integrations.includes(integrationType as any);
};
